<template>
    <input
        type="text"
        :name="this.name"
        :class="this.class"
        :autofocus="this.focus && 'autofocus'"
        v-model="input"
        @click="calculate"
        @keydown="debounce"
    />
</template>

<script>
import _ from "lodash";

export default {
    props: {
        name: String,
        class: String,
        uri: String,
        focus: Boolean,
        value1: String,
        value2: String,
        type: String,
        name1: String,
        name2: String,
    },
    data() {
        return {
            input: this.value1 ? this.value1 : "0,00",
            shareFactor: this.value2 ? this.value2 : "0",
        };
    },
    watch: {
        value1: function(newVal) {
            this.input = newVal;
            this.calculate();
        },
        value2: function(newVal) {
            this.shareFactor = newVal;
            this.calculate();
        }
    },
    methods: {
        calculate() {
            const url = `${this.uri}?type=${this.type}&data[${this.name1}]=${this.input}&data[${this.name2}]=${this.shareFactor}`;
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    const { result } = data;
                    this.$emit("result", result);
                })
                .catch(error => {
                    window.console.log("Error at FunctionInput: " + error);
                });
        },
        debounce: _.debounce(function() {
            this.calculate();
        }, 300),
    }
};
</script>

<style></style>
